import { render } from "./CosmoTimer.vue?vue&type=template&id=4fd159fe&scoped=true"
import script from "./CosmoTimer.vue?vue&type=script&lang=js"
export * from "./CosmoTimer.vue?vue&type=script&lang=js"

import "./CosmoTimer.vue?vue&type=style&index=0&id=4fd159fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd159fe"]])

export default __exports__